module.exports = __webpack_public_path__ + "static/media/PrinterInit.03fbb7a6.mp3";